import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import useLogger from "../../util/Logger";
import "./WorkOrderCompletedWorkItem.css";

function WorkOrderCompletedWorkItem({ property, workOrder, workItem }) {
  const logger = useLogger();
  const navigate = useNavigate();

  const clickWorkItem = () => {
    logger.debug(
      "WorkOrderCompletedWorkItem.clickWorkItem",
      `Navigating to work item '${workItem?.id}'`
    );
    navigate(
      `/property/${property.id}/workorder/${workOrder.id}/workitem/${workItem.id}`
    );
  };

  const view = (
    <tr className="work-order-completed-item" onClick={clickWorkItem}>
      <td>{workItem.reference}</td>
      <td>{workItem.name}</td>
      <td>{workItem.workItemNotes}</td>
      <td>
        {workItem.createdOn
          ? moment(workItem.createdOn).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
      <td>
        {workItem.closedDate
          ? moment(workItem.closedDate).format("DD/MM/YYYY h:mm a")
          : ""}
      </td>
      <td>{workItem.category}</td>
      <td>{workItem.subCategory}</td>
      <td>{workItem.status}</td>
      <td>{workItem.cancellationReason || ""}</td>
      <td>{workItem.cancelledBy || ""}</td>
    </tr>
  );

  return view;
}

WorkOrderCompletedWorkItem.propTypes = {
  property: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  workOrder: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  workItem: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    reference: PropTypes.string,
    createdOn: PropTypes.string,
    closedDate: PropTypes.string,
    category: PropTypes.string,
    subCategory: PropTypes.string,
    workItemNotes: PropTypes.string,
    status: PropTypes.string,
    cancellationReason: PropTypes.string,
    cancelledBy: PropTypes.string
  }).isRequired,
};

export default WorkOrderCompletedWorkItem;
